/* Brunelia : article du Magazine (rv-article). Prix du bouton selon le format choisi, filtres et « Voir tout » du tableau,
   « Ajouter les 3 au panier » du mur. L'ajout d'une affiche passe par form[data-rv-atc] (rv-core.js). */
(function () {
  "use strict";
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* format -> price on the button, format name for the toast */
  document.addEventListener("change", function (e) {
    var i = e.target;
    if (!i.matches || !i.matches(".ra-buy input[name=id]")) return;
    var f = i.closest("form"), out = f.querySelector("[data-ra-price]");
    if (out) out.textContent = i.getAttribute("data-p");
    f.setAttribute("data-fmt", i.getAttribute("data-l") || "");
  });

  /* table: filters and show all */
  $$("[data-ra-tbl]").forEach(function (box) {
    var rows = $$("tbody tr", box), more = box.querySelector("[data-ra-more]");
    $$(".ra-flt button", box).forEach(function (b) {
      b.addEventListener("click", function () {
        $$(".ra-flt button", box).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        var f = b.getAttribute("data-f");
        rows.forEach(function (r) {
          var ok = f === "*" || (f === "offre" ? r.hasAttribute("data-off") : r.getAttribute("data-o") === f);
          r.classList.toggle("is-hidden", !ok);
        });
        if (f !== "*") { box.classList.add("is-open"); if (more) more.hidden = true; }
      });
    });
    if (more) more.addEventListener("click", function () {
      box.classList.add("is-open"); more.hidden = true; more.setAttribute("aria-expanded", "true");
    });
  });

  /* wall of 3: one cart call */
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-ra-trio]");
    if (!b || !window.RV || !RV.cart) return;
    var items = b.getAttribute("data-ra-trio").split(",").filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
    b.disabled = true;
    RV.cart.add(items).then(function () { RV.toast(RV.t("article_js.trio_added"), b.getAttribute("data-img")); })
      .catch(function () {}).then(function () { b.disabled = false; });
  });
})();
